// authSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { loginUser, registerUser } from '../../services/authService';
import { fetchUser } from '../../services/userService';

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user: null,
        loader : false,
        errors: [],
        isAuth: false,
        isSuccess : false,
    },
    reducers: {
        logout: (state) => {
            state.user = null;
            state.isAuth = false;
            localStorage.removeItem('token')
        }
    },
    extraReducers : (builder) => {
        builder
        .addCase(registerUser.pending, (state) => {
            state.loader = true
        })
        .addCase(registerUser.rejected, (state, action) => {
            state.loader = false;
            state.errors = action.payload;
        })
        .addCase(registerUser.fulfilled, (state, action) => {
            state.loader = false;
            state.isSuccess = true
        })
        .addCase(loginUser.pending, (state) => {
            state.loader = true;
            state.isAuth= false
        })
        .addCase(loginUser.rejected, (state, action) => {
            state.loader = false;
            state.errors = action.payload;
            state.isAuth = false
        })
        .addCase(loginUser.fulfilled, (state, action) => {
            state.loader = false;
            state.user = action.payload;
            state.isAuth = true;
            state.isSuccess = true
        })
        .addCase(fetchUser.pending, (state) => {
            state.loader = true
        })
        .addCase(fetchUser.rejected, (state, action) => {
            state.loader = false;
            state.isAuth= false
        })
        .addCase(fetchUser.fulfilled, (state, action) => {
            state.loader = false;
            state.user = action.payload;
            state.isAuth = true
        })
    }
});

export const { logout} = authSlice.actions;
export default authSlice.reducer;
